/**
 * Utilidades de fecha compartidas para todo el módulo Support Engine
 */

/**
 * Parsea de forma segura cualquier formato de fecha o timestamp
 * @param {string|number|Date} dateVal 
 * @returns {Date|null}
 */
export const parseDate = dateVal => {
  if (!dateVal) return null;
  if (dateVal instanceof Date) return isNaN(dateVal.getTime()) ? null : dateVal;
  let s = String(dateVal).trim();
  if (!s || s === 'null' || s === 'undefined' || s.startsWith('0001') || s.startsWith('1900')) return null;
  let d = new Date(s);
  if (isNaN(d.getTime())) {
    d = new Date(s.replace(' ', 'T'));
  }
  if (isNaN(d.getTime()) || d.getFullYear() <= 1970) return null;
  return d;
};

const pad = n => String(n).padStart(2, '0');

const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

/**
 * Formatea una fecha a formato día Mes Año (ej. 7 Octubre 2026)
 * @param {string|number|Date} dateVal 
 * @returns {string}
 */
export const formatDate = dateVal => {
  const d = parseDate(dateVal);
  if (!d) return '-';
  const day = d.getDate();
  const monthName = MESES[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${monthName} ${year}`;
};

/**
 * Formatea una fecha o timestamp a formato de hora (ej. 04:31 PM o 16:31)
 * @param {string|number|Date} dateVal 
 * @param {boolean} hour12 
 * @returns {string}
 */
export const formatTime = (dateVal, hour12 = true) => {
  const d = parseDate(dateVal);
  if (!d) return '';
  const minutes = pad(d.getMinutes());
  if (hour12) {
    const hours = d.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hours12 = pad(hours % 12 || 12);
    return `${hours12}:${minutes} ${ampm}`;
  }
  return `${pad(d.getHours())}:${minutes}`;
};

/**
 * Formatea una fecha con día Mes Año y hora completa (ej. 7 Octubre 2026, 04:31 PM)
 * @param {string|number|Date} dateVal 
 * @returns {string}
 */
export const formatDateTime = dateVal => {
  const d = parseDate(dateVal);
  if (!d) return '';
  const time = formatTime(d, true);
  return time ? `${formatDate(d)}, ${time}` : formatDate(d);
};

/**
 * Formatea una fecha a formato legible (ej. Hoy, 12 Oct 2023)
 * @param {string|number|Date} dateVal 
 * @returns {string}
 */
export const formatDateLabel = dateVal => {
  const d = parseDate(dateVal);
  if (!d) return '';
  try {
    const today = new Date();
    if (d.toDateString() === today.toDateString()) {
      return 'Hoy';
    }
    return d.toLocaleDateString([], { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '';
  }
};
